export enum ProfilePageQueryParamsEnum {
  appDownload = 'auto_download',
  TAB = 'tab',
  brandId = 'brandId',
  TARGET = 'target',
}
